import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { UpsellButtonInterface } from 'common/types/entities/button-interface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createUpsellAgreeButton(
  parentId: string,
  masterBlockId?: MasterBlockId,
): UpsellButtonInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.UpsellAgreeButton,
      parentId,
      masterBlockId,
    ),
    text: '',
    textFontSize: 23,
    subTextFontSize: 16,
    lineHeight: 23,
    textColor: 'rgba(255, 255, 255, 1)',
    subTextColor: 'rgba(255,255,255,0.8)',
    background: 'rgba(23, 169, 67, 1)',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2)',
    mobileBoxShadow: 'none',
    width: 'auto',
    mobileWidth: '100%',
    alignSelf: 'center',
    border: {
      width: 3,
      style: BorderStyleEnum.solid,
      radius: {
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        borderBottomRightRadius: 3,
        borderBottomLeftRadius: 3,
      },
      color: 'rgba(22, 144, 59, 1)',
      type: BorderTypeEnum.bottomOnly,
    },
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    padding: {
      paddingTop: 15,
      paddingRight: 92,
      paddingBottom: 15,
      paddingLeft: 92,
    },
    mobilePadding: {
      paddingTop: 14,
      paddingRight: 5,
      paddingBottom: 14,
      paddingLeft: 5,
    },
    childIds: [],
  }
}

export function createUpsellDisagreeButton(
  parentId: string,
  masterBlockId?: MasterBlockId,
): UpsellButtonInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.UpsellDisagreeButton,
      parentId,
      masterBlockId,
    ),
    text: '',
    textFontSize: 20,
    lineHeight: 23,
    subTextFontSize: 14,
    textColor: 'rgba(74, 74, 74, 1)',
    subTextColor: 'rgba(141,139,139,1)',
    background: 'rgba(229, 229, 229, 1)',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2)',
    mobileBoxShadow: 'none',
    width: 'auto',
    mobileWidth: '100%',
    alignSelf: 'center',
    border: {
      width: 3,
      style: BorderStyleEnum.solid,
      radius: {
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        borderBottomRightRadius: 3,
        borderBottomLeftRadius: 3,
      },
      color: 'rgba(198, 198, 198, 1)',
      type: BorderTypeEnum.bottomOnly,
    },
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    padding: {
      paddingTop: 15,
      paddingRight: 86,
      paddingBottom: 15,
      paddingLeft: 86,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    childIds: [],
  }
}
